const API_BASE_URL =
    process.env.NODE_ENV === "development" ?
        'http://127.0.0.1:5001/withlove-d08f3/us-central1/api/v1' :
        'https://api.withlove.page/v1';

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Erro desconhecido");
    }
    return response.json();
};

export const apiService = {
    createUser: async (userData) => {
        const response = await fetch(`${API_BASE_URL}/users`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(userData),
        });
        return handleResponse(response);
    },

    getUserBySlug: async (slug) => {
        const response = await fetch(`${API_BASE_URL}/users/slug/${slug}`);
        return handleResponse(response);
    },

    getUserById: async (userId) => {
        const response = await fetch(`${API_BASE_URL}/users/${userId}`);
        return handleResponse(response);
    },

    updateUser: async (userId, userData) => {
        const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(userData),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Erro ao atualizar usuário");
        }
    },

    checkout: async ({ userId, email, planId }) => {
        const response = await fetch(`${API_BASE_URL}/checkout`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId, email, planId }),
        });
        return handleResponse(response);
    },
};
